@for (item of preQuestionItems; track item.genID) {
<div class="preQuestionaireItem"
     id="preQuestionaireItem{{item.genID}}"
     [class.d-block]="item.aspNetControlId === ASPNetControl.Label">
  @if(isFirstItemOfGroup(item, preQuestionItems))
  {
  <span
    class="btn-block "
    (click)="removegroup(item, preQuestionItems)">
    <span class="fa fa-times btn-block ">
    </span>
  </span>
  }
  @if(!item.group)
  {
  <controls name="controls" id="controls{{item.genID}}"
            #Controls="ngModel"
            [item]="item">
  </controls>
  }
  @if(item.group)
  {
  <span class="pqItemGroup">
    @if(item.aspNetControlId === ASPNetControl.Repeating_Section)
    {
    <span>
      @if(item.required ? adddefaultgroup(item): false)
      {
      <span></span>
      }
      <prequestionaire [preQuestionItems]="item.preQuestionNumber">
      </prequestionaire>
      <button class="btn btn-primary btn-success btn-sm" (click)="addgroup(item)" type="button">
        <div class="AddItem">
          <div class="AddItemText">
            Add
          </div>
        </div>
      </button>
    </span>
    }
  </span>
  }
</div>
}
